/**
 * analytics.js — Google Analytics 4 (GA4).
 *
 * Measurement ID defaults to the Ella Froze property (G-3DLD5HNTH1); override
 * with REACT_APP_GA4_ID in frontend/.env if needed. The ID is public (it ships
 * in the page HTML), so hardcoding the default is safe.
 *
 * SPA note: GA4's auto page_view only fires on the first load, so route
 * changes are tracked manually via trackPageview() (wired in App.js) with
 * send_page_view:false on config to avoid double-counting.
 */
const GA_ID = process.env.REACT_APP_GA4_ID || "G-3DLD5HNTH1";

let loaded = false;

export function initAnalytics() {
  if (!GA_ID || loaded || typeof window === "undefined") return;
  loaded = true;

  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(s);

  window.dataLayer = window.dataLayer || [];
  window.gtag = function () { window.dataLayer.push(arguments); };
  window.gtag("js", new Date());
  // We send page_view ourselves on each route change.
  window.gtag("config", GA_ID, { send_page_view: false });
}

export function trackPageview(path) {
  if (!GA_ID || typeof window === "undefined" || !window.gtag) return;
  window.gtag("event", "page_view", {
    page_path: path,
    page_location: window.location.href,
    page_title: document.title,
  });
}

/** Optional: track a custom event, e.g. trackEvent("add_to_cart", { item: name }). */
export function trackEvent(name, params = {}) {
  if (!GA_ID || typeof window === "undefined" || !window.gtag) return;
  window.gtag("event", name, params);
}
